export default __webpack_public_path__ + "static/media/MachinehackCoin.5f8fb259.svg";